import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router'
import { PARAMS_NAME } from '../../constants'
import qs from 'query-string'

import CartContainer from './CartContainer'
import FoodContainer from './FoodContainer'
import OrderFormContainer from './OrderFormContainer'
import { disableBrowserBack } from '../../utils/helper'

const ListFoodDesktop = () => {
    const location = useLocation()
    const params = qs.parse(location.search)
    const [stepOrder, setStepOrder] = useState(
        params[PARAMS_NAME.ORDER_WAIT_PAYMENT] ? 'submit' : 'ordering'
    )

    useEffect(() => {
        disableBrowserBack()
    }, [])

    return (
        <div className="food-desk-wrap">
            <div className="food-desk">
                {stepOrder === 'ordering' ? (
                    <FoodContainer />
                ) : (
                    <OrderFormContainer
                        backToOrder={() => setStepOrder('ordering')}
                    />
                )}
                <CartContainer
                    setStepOrder={setStepOrder}
                    stepOrder={stepOrder}
                />
            </div>
        </div>
    )
}

export default ListFoodDesktop
